import React from 'react';
import { Navigate } from 'react-router';
import { HIDE_SYSTEM_ROUTE } from '../../configs';
import ApplicantPage from './components/ApplicantPage';

const routes = [
  // {
  //   path: '/',
  //   component: () => <Navigate to="/applicants" />,
  //   weight: 2,
  //   hideOnMenu: HIDE_SYSTEM_ROUTE,
  //   permission: [],
  //   children: [],
  //   loginRequired: true,
  // },
  {
    path: '/applicants',
    name: 'menu.applicants',
    icon: 'applicant_1',
    customIcon: true,
    loginRequired: true,
    component: ApplicantPage,
    weight: 2,
    permission: [],
    children: [],
  },
];

export default routes;
